var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrossCircleIconSv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon cross-circle-icon",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "gray"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.787 4.213a.5.5 0 01.048.651l-.048.056L8.707 8l3.08 3.08a.5.5 0 01-.651.755l-.056-.048L8 8.707l-3.08 3.08a.5.5 0 01-.755-.651l.048-.056L7.293 8l-3.08-3.08a.5.5 0 01.651-.755l.056.048L8 7.293l3.08-3.08a.5.5 0 01.707 0z"
  })));
}

export default SvgCrossCircleIconSv;